module.exports = __webpack_public_path__ + "img/92141.cbdad404.svg";